import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'country-livestock-policies',
  templateUrl: './country-livestock-policies.component.html',
  styleUrls: ['./country-livestock-policies.component.scss']
})
export class CountryLivestockPoliciesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
